import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IJsonPlaceholderUser, IJsonPlaceholderComment, IJsonPlaceholderPost } from '../interfaces/json-placholder.interface';

@Injectable()
export class JsonPlaceholderService {

  private url: string = "https://jsonplaceholder.typicode.com";

  constructor(private http: HttpClient) { }

  fetchUsers = (): Observable<IJsonPlaceholderUser[]> => {
    return this.http.get<IJsonPlaceholderUser[]>(`${this.url}/users`);
  }

  fetchPosts = (userId): Observable<IJsonPlaceholderPost[]> => {
    return this.http.get<IJsonPlaceholderPost[]>(`${this.url}/posts`, { params: { userId: userId } });
  }

  fetchComments = (postId): Observable<IJsonPlaceholderComment[]> => {
    return this.http.get<IJsonPlaceholderComment[]>(`${this.url}/comments`, { params: { postId: postId } });
  }

}
